module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Account-Creation_02-2b63799c58f7c1dcf16896f59d6be0a6.jpg";